import { render } from "./WCInput.vue?vue&type=template&id=1123f4b8&scoped=true"
import script from "./WCInput.vue?vue&type=script&lang=js"
export * from "./WCInput.vue?vue&type=script&lang=js"

import "./WCInput.vue?vue&type=style&index=0&id=1123f4b8&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1123f4b8"]])

export default __exports__